<div edsGrid>
  <div
    edsGrid
    edsPadding
    edsPaddingBottom="xl"
    [edsSpacing]="(isHandheld$ | async) ? 'xxl' : 'xxxl'"
  >
    <div class="container" *ngIf="data$ | async as data">
      <div edsRow>
        <eds-title
          edsCol
          [columnNumbers]="{ s: 4, m: 6, l: 10 }"
          title="{{ 'literature.lit-featured-literature-title' | translate }}"
          size="h3"
          [isLight]="true"
          edsSpacing="lg"
          theme="dark"
        ></eds-title>
        <ng-container>
          <ng-container *ngFor="let document of data">
            <div edsCol [columnNumbers]="{ s: 4, m: 6, l: 12 }" edsSpacing="md">
              <eds-thumbnail
                [hasBorders]="true"
                [hasShadows]="true"
                [headingLevel]="3"
                [titleLink]="document.href"
                [previewSrc]="document.imageUrl"
                [title]="document.dctermsTitle"
                buttonText="{{
                  'literature.lit-featured-literature-link-text' | translate
                }}"
                [isNewWindow]="true"
                [href]="document.href"
                [body]="getDescription(document.dctermsDescription)"
                [type]="document.imageUrl ? false : document.fileExtension"
              >
              </eds-thumbnail>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
